module.exports = __webpack_public_path__ + "static/media/bg-blog-journal.7c791ae2.png";